import { OrderResponseFromStatusV2 } from 'business/shared/infra';
import { featureAdoptionService } from 'shared/services/feature-adoption';
import OrdersUtils from 'utils/OrdersUtils';
import { AdoptionData, FeatureAdoptionTypes } from '../domain/models';

export function mainKanbanCardAdoptionService({ order }: Params) {
  const _STORE_ITEM_NAME = 'main_kanban_card_adoption';
  const storeId = order?.store_id;
  const partnerId = order?.partner_id;
  const isInCooking = OrdersUtils.isBeingCooking(order?.partner_order_state);
  const isMarketplace = OrdersUtils.isMarketPlace(order?.delivery_method);
  const isRTAssign = !!order.store_keeper_info?.id || !!order.deliveryboy_id;
  const showOrderReadyAdoption = isInCooking && !isMarketplace && !isRTAssign;

  const {
    MAX_VIEWS,
    getStoredData,
    hasDayElapsed,
    initialAdoptionValue,
    updateStoredData,
  } = featureAdoptionService<FeatureAdoptionTypes>({
    storageItemName: _STORE_ITEM_NAME,
  });

  const addInitialStoredData = () => {
    const initialValues: Record<FeatureAdoptionTypes, AdoptionData> = {
      [FeatureAdoptionTypes.orderReady]: initialAdoptionValue(
        FeatureAdoptionTypes.orderReady,
      ),
    };

    const storedData: AdoptionData[] = [
      ...(showOrderReadyAdoption
        ? [initialValues[FeatureAdoptionTypes.orderReady]]
        : []),
    ];

    if (storedData.length > 0) {
      localStorage.setItem(_STORE_ITEM_NAME, JSON.stringify(storedData));
    }
  };

  const addStoredData = (type: FeatureAdoptionTypes) => {
    const storedData = getStoredData();

    const initialValues: Record<
      FeatureAdoptionTypes,
      ReturnType<typeof initialAdoptionValue>
    > = {
      [FeatureAdoptionTypes.orderReady]: initialAdoptionValue(
        FeatureAdoptionTypes.orderReady,
      ),
    };

    const valueToAdd = initialValues[type];
    if (valueToAdd !== undefined) {
      storedData.push(valueToAdd);
    }

    localStorage.setItem(_STORE_ITEM_NAME, JSON.stringify(storedData));
  };

  return {
    getStoredData,
    updateStoredData,
    hasDayElapsed,
    addInitialStoredData,
    addStoredData,
    MAX_VIEWS,
    storeId,
    partnerId,
    showOrderReadyAdoption,
  };
}

type Params = {
  order: OrderResponseFromStatusV2;
};
